module.exports = __webpack_public_path__ + "img/send-icon.017868d6.svg";